export class Service {
  id: string
  code: string
  name: string
  scopeOfWork: string
  price: number
  cost: number

  constructor () {
    this.code = ''
    this.name = ''
    this.scopeOfWork = ''
    this.cost = 0.00
  }
}
